/* eslint-disable */
// @ts-ignore
import React, { useEffect, useState } from "react";
import { UseFormLoaderProps, useFormLoader } from "./hooks/useFormLoader";
// import "./Form.scss"
import { IdentityInfo, StepBuilder, initFormState, type FormElementPropertiesBase } from "@episerver/forms-sdk";
import { FormProvider } from "./context/FormProvider";
import LoadingIndicator from "3-components/LoadingIndicator/LoadingIndicator";
import { FormBodyDonorDebit } from "./components/FormBodyDonorDebit";
import { useDebitContext } from "4-sections/DonorDetailBlock/DebitPayment/useDebitContext";
import { CustomFormContainerProperties, CustomFormContainer } from "./types/form";

interface FormProps {
    /**
     * The form key that identifies the form
     */
    formKey: string;
    /**
     * The code of the form language
     */
    language?: string;
    /**
     * The base url of Headless Form API
     */
    baseUrl: string;
    /**
     * Access token for form submit
     */
    identityInfo?: IdentityInfo;
    /**
     * The instance of useHistory() received from react-router-dom
     */
    history?: any;
    /**
     * The public url of current page
     */
    currentPageUrl?: string;
    /**
     * The endpoint url of Optimizely Graph 
     */
    optiGraphUrl?: string;
}

interface FormElementProperties extends FormElementPropertiesBase {
  predefinedValue: string;
}

export function FormDonorDebit({formKey, language, baseUrl, identityInfo, history, currentPageUrl, optiGraphUrl}: FormProps){

  const { data: formData, loading: isLoading } = useFormLoader({ formKey, language, baseUrl, optiGraphUrl } as UseFormLoaderProps);

  const { paymentData } = useDebitContext();

  if(isLoading){
    return <LoadingIndicator />
  }
  
  if (!formData) {
    return <></>;
  }

  const stepBuilder = new StepBuilder(formData);
  const form = stepBuilder.buildForm();
  const debitPaymentIdField = form.formElements.find(formField => formField.displayName == 'DebitPaymentId');

  if(debitPaymentIdField) {
    debitPaymentIdField.properties = {
      ...debitPaymentIdField.properties,
      predefinedValue: paymentData.submissionId
    } as FormElementProperties;
  }

  const state = initFormState(form, currentPageUrl, history);
  // indentify the form for GA4 dataLayer
  ( state.formContainer.properties as CustomFormContainerProperties ).name = 'Donor Debit Payment Form';
  ( state.formContainer as CustomFormContainer ).type = 'donor update - debit form';

  {/* finally return the form */}
  return (
      <FormProvider initialState={state}>
          <FormBodyDonorDebit identityInfo={identityInfo} baseUrl={baseUrl} history={history} currentPageUrl={currentPageUrl}/>
      </FormProvider>
  )
}